import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  description: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '1.5rem', md: '1rem' },
        py: { xs: 3, sm: 4, md: 5 },
        mb: { xs: 3, sm: 4, md: 5 },
        pr: { xs: 0, md: 5 },
        borderBottom: '1px solid #e0e0e0ff'
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', md: '40%' },
          padding: { xs: '1rem', sm: '1.5rem', md: '2rem' },
          marginLeft: { xs: 0, md: '2rem' },
          display: 'flex',
          justifyContent: { xs: 'flex-start', md: 'center' },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: '1.5rem', sm: '1.875rem', md: '2rem', lg: '2.25rem' },
            fontWeight: 700,
            textAlign: { xs: 'left', md: 'center' },
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: { xs: '100%', md: '60%' },
          px: { xs: '1rem', md: 0 },

        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: '0.875rem', sm: '0.938rem', md: '1rem' },
            lineHeight: { xs: 1.6, md: 1.7 },
            color: 'text.secondary',
            textAlign: { xs: 'left', md: 'center' },
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default PageHeader;
